import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../components/Header";
import api from "../../services/api";
import { showSuccess, showError } from "../../services/alert";

const AgricultorForm = () => {
  const { id } = useParams();
  const isEditing = Boolean(id && id !== "create");
  const navigate = useNavigate();

  const [form, setForm] = useState({ nome: "", ativo: true });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isEditing) {
      setLoading(true);
      api.get(`/agricultores/${id}`)
        .then(({ data }) => setForm({ nome: data.nome, ativo: data.ativo }))
        .catch(() => showError("Erro ao carregar registro."))
        .finally(() => setLoading(false));
    }
  }, [id, isEditing]);

  const handleChange = (e) => setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));
  const handleToggle = (e) => setForm(prev => ({ ...prev, ativo: e.target.checked }));

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.nome.trim()) {
      showError('O campo "Nome" é obrigatório.');
      return;
    }

    const payload = {
      id: isEditing ? Number(id) : 0,
      nome: form.nome.trim(),
      ativo: form.ativo
    };

    setLoading(true);
    try {
      if (isEditing) {
        await api.put(`/agricultores/${id}`, payload);
        showSuccess("Agricultor atualizado com sucesso.");
      } else {
        await api.post("/agricultores", payload);
        showSuccess("Agricultor criado com sucesso.");
      }
      navigate("/agricultores");
    } catch (err) {
      showError(err?.response?.data?.message || "Erro ao salvar.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <Header />
      <div className="card shadow-lg border-0 rounded-3">
        <div className="card-header bg-success text-white d-flex align-items-center gap-3 rounded-top-3">
          <button
            className="btn btn-light btn-sm d-flex align-items-center gap-1"
            onClick={() => navigate("/agricultores")}
            disabled={loading}
          >
            <i className="bi bi-arrow-left text-success" />
            <span className="text-success fw-semibold">Voltar</span>
          </button>
          <h5 className="mb-0">
            {isEditing ? "Editar Agricultor" : "Novo Agricultor"}
          </h5>
        </div>

        <div className="card-body">
          <form onSubmit={handleSubmit} className="row g-4">
            <fieldset className="border p-3 rounded-3">
              <legend className="px-3 text-success fw-semibold">Dados do Agricultor</legend>

              <div className="col-md-6">
                <label className="form-label fw-semibold">Nome *</label>
                <input
                  type="text"
                  name="nome"
                  value={form.nome}
                  onChange={handleChange}
                  className="form-control rounded-3"
                  maxLength={160}
                  required
                  disabled={loading}
                />
              </div>

              {isEditing && (
                <div className="col-md-6 d-flex align-items-end">
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      role="switch"
                      checked={form.ativo}
                      onChange={handleToggle}
                      disabled={loading}
                    />
                    <label className="form-check-label ms-2">Ativo</label>
                  </div>
                </div>
              )}

              <div className="col-12 d-flex justify-content-end mt-3">
                <button
                  type="submit"
                  className="btn btn-success me-2 d-flex align-items-center gap-1"
                  disabled={loading}
                >
                  <i className="bi bi-save" />
                  <span>{loading ? "Salvando..." : "Salvar"}</span>
                </button>
                <button
                  type="button"
                  className="btn btn-secondary d-flex align-items-center gap-1"
                  onClick={() => navigate("/agricultores")}
                  disabled={loading}
                >
                  <i className="bi bi-x-circle" />
                  <span>Cancelar</span>
                </button>
              </div>
            </fieldset>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AgricultorForm;
